export default {
  "nl": {
    "inspiration": {
      "actions": {
        "delete": "Verwijderen",
        "deleteMultipleInspirations": "Verwijder...",
        "delete_cancel": "Annuleren",
        "goBackToInspirationLists": "Inspiraties",
        "new": "Nieuwe Inspiratie"
      },
      "labels": {
        "noInspirations": "Nog geen inspiraties",
        "upload_autoclose": "Dit venster sluit automatisch wanneer alle bestanden geüpload zijn."
      },
      "toasts": {
        "upload_success": "{count} inspiratie succesvol geüpload | {count} inspiraties succesvol geüpload"
      }
    }
  }
}